import Button, { PrimaryButton } from '@theme/components/Button/src/tsx/Button';
import PropTypes from 'prop-types';

export default function Nav({ canPurchase, generalData, getLabel, onNextBtnClick, onPrevBtnClick, step }) {
	const getPrevButton = (label) => (
		<Button onClick={onPrevBtnClick} testId="prc-nav-button-prev">
			<span className="arrow" aria-hidden="true">
				arrow_left_alt
			</span>
			<span>{label}</span>
		</Button>
	);

	const getNextButton = (label) => (
		<PrimaryButton onClick={onNextBtnClick} testId="prc-nav-button-next">
			<span>{label}</span>
		</PrimaryButton>
	);

	const getCta = () => {
		if (canPurchase) {
			return getNextButton(getLabel('nav_next_buy'));
		} else {
			const { label, url } = generalData.quote.actions.link;
			if (url && label) {
				return <PrimaryButton href={url}>{label}</PrimaryButton>;
			}

			return null;
		}
	};

	const getNavButtons = () => {
		switch (step) {
			case 1:
				return [getPrevButton(getLabel('nav_prev_change_plan')), getNextButton(getLabel('nav_next_review'))];
			case 2:
				return [getPrevButton(getLabel('nav_prev_change_packages')), getCta()];
			default:
				return [null, null];
		}
	};

	const [prevButton, nextButton] = getNavButtons();

	return prevButton || nextButton ? (
		<nav className="prc-nav">
			<div className="prc-nav__btn prc-nav__btn--prev">{prevButton}</div>
			<div className="prc-nav__btn prc-nav__btn--next">{nextButton}</div>
		</nav>
	) : null;
}

Nav.propTypes = {
	canPurchase: PropTypes.bool.isRequired,
	generalData: PropTypes.object.isRequired,
	getLabel: PropTypes.func.isRequired,
	onNextBtnClick: PropTypes.func.isRequired,
	onPrevBtnClick: PropTypes.func.isRequired,
	step: PropTypes.number.isRequired,
};
